import {
  ACHIEVEMENT_MODES,
  type QuestAchievementType,
} from '@didaskill/domain/user-achievements/constants';

import { GAMIFICATION_RULES } from './rules';

export const QUEST_ACHIEVEMENT_TYPES: QuestAchievementType[] = Object.entries(GAMIFICATION_RULES)
  .filter(([, value]) => value.mode === ACHIEVEMENT_MODES.QUEST)
  .map(([key]) => key as QuestAchievementType);
